export default "__VITE_ASSET__DVrTGqgL__"